"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.play = void 0;
var play = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "PLAY_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "PLAY"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "PLAY"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M46,32c0-1.099-0.592-2.06-1.475-2.583l0,0L22.561,16.438c-0.008-0.005-0.016-0.009-0.024-0.014l-0.011-0.007l0,0\r\n\t\t\t\tC22.079,16.153,21.557,16,21,16c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3c0.557,0,1.079-0.152,1.526-0.417l0,0l0.011-0.007\r\n\t\t\t\tc0.008-0.006,0.016-0.01,0.024-0.014l21.964-12.979l0,0C45.408,34.061,46,33.1,46,32z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M46,32c0-1.099-0.592-2.06-1.475-2.583l0,0L22.561,16.438c-0.008-0.005-0.016-0.009-0.024-0.014l-0.011-0.007l0,0\r\n\t\t\t\tC22.079,16.153,21.557,16,21,16c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3c0.557,0,1.079-0.152,1.526-0.417l0,0l0.011-0.007\r\n\t\t\t\tc0.008-0.006,0.016-0.01,0.024-0.014l21.964-12.979l0,0C45.408,34.061,46,33.1,46,32z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.play = play;